import './PriceFixCombo.css';

export function sanitizePriceInput(raw: string): string {
  const normalized = raw.replace(',', '.').replace(/[^\d.]/g, '');
  const parts = normalized.split('.');
  return parts.length > 1 ? parts[0] + '.' + parts.slice(1).join('') : normalized;
}

interface PriceFixComboProps {
  value: string;
  onValueChange: (value: string) => void;
  isFixed: boolean;
  onFixedChange: (fixed: boolean) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  /** По умолчанию true — кнопка «ФИКС» как в комбо проекта; false — только поле и ₽ (например базовая стоимость чтеца без ФИКС) */
  showFixButton?: boolean;
  /** Доп. элемент слева от поля (например кнопка списка базовых позиций) */
  leadingSlot?: React.ReactNode;
  /** Между полем суммы и символом ₽ (например сброс выбора базы) */
  betweenInputAndCurrency?: React.ReactNode;
  onInputFocus?: React.FocusEventHandler<HTMLInputElement>;
  onInputBlur?: React.FocusEventHandler<HTMLInputElement>;
  onInputKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

export function PriceFixCombo({
  value,
  onValueChange,
  isFixed,
  onFixedChange,
  placeholder = '0',
  className = '',
  disabled = false,
  inputMode = 'decimal',
  showFixButton = true,
  leadingSlot,
  betweenInputAndCurrency,
  onInputFocus,
  onInputBlur,
  onInputKeyDown,
}: PriceFixComboProps) {
  return (
    <div className={`price-fix-combo ${className}`.trim()}>
      {leadingSlot ? <div className="price-fix-combo__leading">{leadingSlot}</div> : null}
      <input
        className="price-fix-combo__input"
        type="text"
        inputMode={inputMode}
        value={value}
        disabled={disabled}
        onChange={(e) => onValueChange(sanitizePriceInput(e.target.value))}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        onKeyDown={onInputKeyDown}
        placeholder={placeholder}
      />
      {betweenInputAndCurrency ? (
        <div className="price-fix-combo__between">{betweenInputAndCurrency}</div>
      ) : null}
      <span className="price-fix-combo__currency" aria-hidden>
        ₽
      </span>
      {showFixButton ? (
        <button
          type="button"
          className={`price-fix-combo__fix ${isFixed ? 'price-fix-combo__fix_active' : ''}`.trim()}
          aria-pressed={isFixed}
          disabled={disabled}
          onClick={() => onFixedChange(!isFixed)}
          title={isFixed ? 'Снять фиксированную цену' : 'Зафиксировать цену'}
        >
          ФИКС
        </button>
      ) : null}
    </div>
  );
}
